module.exports = __webpack_public_path__ + "img/bg-mision-2-6.0634627d.jpg";